import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SortOrder } from '@wix/ambassador-individual-scheduling-assistant-v1-digest/types';
import { digestApiToDigestEntity } from '../../entities/Digest/converters';
import { DigestType } from '../../entities/Digest/Digest';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class DigestClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createDigestImpl", void 0);
    _defineProperty(this, "queryDigestsImpl", void 0);
    _defineProperty(this, "updateDigestImpl", void 0);
    _defineProperty(this, "markTaskAsDoneImpl", void 0);
    _defineProperty(this, "pauseTaskImpl", void 0);
    _defineProperty(this, "deleteDigestImpl", void 0);
    _defineProperty(this, "bulkUpsertContactsImpl", void 0);
    _defineProperty(this, "listFullTaskDigestsImpl", void 0);
    _defineProperty(this, "getKnowledgeImpl", void 0);
  }
  async createDigest(type, entityId, data) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }
      const response = await this.request(this.createDigestImpl({
        digest: {
          type,
          data,
          ...(entityId && {
            entityId
          })
        }
      }), ...args);
      return digestApiToDigestEntity(response.digest);
    } catch (error) {
      this.logError('createDigest', 'Failed to create digest', {
        data
      }, error);
      throw error;
    }
  }
  async deleteDigest(digestId) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      await this.request(this.deleteDigestImpl({
        digestId
      }), ...args);
    } catch (error) {
      this.logError('deleteDigest', 'Failed to delete digest', {
        digestId
      }, error);
      throw error;
    }
  }
  async queryTasksDigests(query) {
    try {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      return this.queryDigests({
        filter: {
          type: DigestType.TASK
        },
        ...query
      }, ...args);
    } catch (error) {
      this.logError('getTasksDigests', 'Failed to get tasks digests', {
        query
      }, error);
      throw error;
    }
  }
  async queryRoutinesDigests(query) {
    try {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      return this.queryDigests({
        filter: {
          type: DigestType.ROUTINE
        },
        ...query
      }, ...args);
    } catch (error) {
      this.logError('getRoutinesDigests', 'Failed to get routines digests', {
        query
      }, error);
      throw error;
    }
  }
  async getTaskDigest(taskId) {
    try {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      const result = await this.queryDigests({
        filter: {
          type: DigestType.TASK,
          entityId: taskId
        }
      }, ...args);
      if (!result.items || result.items.length === 0) {
        return null;
      }
      return result.items[0];
    } catch (error) {
      this.logError('getTaskDigest', 'Failed to get task digest', {}, error);
      throw error;
    }
  }
  async getFullTaskDigest(taskId) {
    try {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      const result = await this.queryDigests({
        filter: {
          entityId: taskId
        }
      }, ...args);
      const taskDigest = result.items.find(item => item.type === DigestType.TASK);
      const taskProgressDigests = result.items.find(item => item.type === DigestType.TASK_PROGRESS);
      const taskPlanDigest = result.items.find(item => item.type === DigestType.TASK_PLAN);
      if (!taskDigest) {
        return null;
      }
      const fullTaskDigest = taskDigest;
      if (taskProgressDigests) {
        fullTaskDigest.data.taskProgress = taskProgressDigests.data.entries;
      }
      if (taskPlanDigest != null && taskPlanDigest.data) {
        fullTaskDigest.data.plan = taskPlanDigest.data;
      }
      return fullTaskDigest;
    } catch (error) {
      this.logError('getFullTaskDigest', 'Failed to get full task digest', {}, error);
      throw error;
    }
  }
  async getRoutineDigest(routineId) {
    try {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }
      const result = await this.queryDigests({
        filter: {
          type: DigestType.ROUTINE,
          entityId: routineId
        }
      }, ...args);
      if (!result.items || result.items.length === 0) {
        return null;
      }
      return result.items[0];
    } catch (error) {
      this.logError('getRoutineDigest', 'Failed to get routine digest', {}, error);
      throw error;
    }
  }
  async getCategoriesDigest(entityId) {
    try {
      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }
      const result = await this.queryDigests({
        filter: {
          type: DigestType.CATEGORY,
          entityId
        }
      }, ...args);
      if (!result.items || result.items.length === 0) {
        return null;
      }
      return result.items[0];
    } catch (error) {
      this.logError('getCategoriesDigest', 'Failed to get categories digest', {}, error);
      throw error;
    }
  }
  async queryEntityDigestByType(type, entityId) {
    try {
      for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
        args[_key9 - 2] = arguments[_key9];
      }
      const result = await this.queryDigests({
        filter: {
          type,
          entityId
        }
      }, ...args);
      if (!result.items || result.items.length === 0) {
        return null;
      }
      return result.items[0];
    } catch (error) {
      this.logError('queryEntityDigestByType', 'Failed to query digest by type', {
        type,
        entityId
      }, error);
      throw error;
    }
  }
  async updateDigestData(_ref, data) {
    let {
      id,
      revision
    } = _ref;
    try {
      for (var _len0 = arguments.length, args = new Array(_len0 > 2 ? _len0 - 2 : 0), _key0 = 2; _key0 < _len0; _key0++) {
        args[_key0 - 2] = arguments[_key0];
      }
      const response = await this.request(this.updateDigestImpl({
        digest: {
          id,
          revision,
          data
        },
        fieldMask: ['data']
      }), ...args);
      return digestApiToDigestEntity(response.digest);
    } catch (error) {
      this.logError('updateDigestData', 'Failed to update digest', {
        id,
        revision,
        data
      }, error);
      throw error;
    }
  }
  async markTaskAsDone(taskId) {
    try {
      for (var _len1 = arguments.length, args = new Array(_len1 > 1 ? _len1 - 1 : 0), _key1 = 1; _key1 < _len1; _key1++) {
        args[_key1 - 1] = arguments[_key1];
      }
      const {
        taskDigest
      } = await this.request(this.markTaskAsDoneImpl({
        taskId
      }), ...args);
      if (taskDigest) {
        return taskDigest;
      }
      throw new Error('Failed to mark task as done');
    } catch (error) {
      this.logError('markTaskAsDone', 'Failed to mark task as done', {
        taskId
      }, error);
      throw error;
    }
  }
  async pauseTask(taskId) {
    try {
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }
      const {
        taskDigest
      } = await this.request(this.pauseTaskImpl({
        taskId
      }), ...args);
      if (taskDigest) {
        return taskDigest;
      }
      throw new Error('Failed to pause task');
    } catch (error) {
      this.logError('pauseTask', 'Failed to pause task', {
        taskId
      }, error);
      throw error;
    }
  }
  async listFullTaskDigests(query) {
    try {
      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }
      const {
        digests,
        pagingMetadata
      } = await this.request(this.listFullTaskDigestsImpl(query), ...args);
      if (!digests) {
        throw new Error('digests is not an array');
      }
      return {
        items: digests.map(digest => digestApiToDigestEntity(digest)),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('listFullTaskDigests', 'Failed to list full task digests', {
        query
      }, error);
      throw error;
    }
  }
  async bulkUpsertContacts(contacts) {
    try {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }
      const {
        accepted
      } = await this.request(this.bulkUpsertContactsImpl({
        contacts
      }), ...args);
      return accepted ?? false;
    } catch (error) {
      this.logError('bulkUpsertContacts', 'Failed to bulk upsert contacts', {
        contactsCount: contacts.length
      }, error);
      throw error;
    }
  }
  async getKnowledge() {
    try {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }
      const {
        knowledge
      } = await this.request(this.getKnowledgeImpl({}), ...args);
      return knowledge ?? '';
    } catch (error) {
      this.logError('getKnowledge', 'Failed to get knowledge', {}, error);
      throw error;
    }
  }
  convertToEntity() {
    throw new Error('convertToEntity is not implemented');
  }
  getServiceNameForLogs() {
    return 'DigestClient';
  }
  async queryDigests(query) {
    try {
      for (var _len14 = arguments.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        args[_key14 - 1] = arguments[_key14];
      }
      const {
        digests,
        pagingMetadata
      } = await this.request(this.queryDigestsImpl({
        query: {
          sort: [{
            fieldName: 'createdDate',
            order: SortOrder.DESC
          }],
          ...query
        }
      }), ...args);
      if (!digests) {
        throw new Error('digests is not an array');
      }
      return {
        items: digests.map(digest => digestApiToDigestEntity(digest)),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryDigests', 'Failed to query digests', {
        query
      }, error);
      throw error;
    }
  }
}
//# sourceMappingURL=DigestClientBase.js.map